import React, { useContext } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Pagination, PowerTable, NoInformationFound } from 'Components';
import AppContext from 'src/AppContext';
import TemplatesDesktopSearchHeader from './TemplatesDesktopSearchHeader/TemplatesDesktopSearchHeader';
import TemplatesDesktopHeader from './TemplatesDesktopHeader/TemplatesDesktopHeader';
import './TemplatesDesktop.css';

const TemplatesDesktop = ({
  data,
  tabs,
  onPinClick,
  onMenuRowClick,
  onPageChange,
  onPageSizeChange,
  onTabsChange,
  powerTableIndex,
  globalSearch,
  setAppState,
  userName,
  onSearchDownload,
  setPageState,
  onOptionClick,
  menuOptions,
  rowRules,
  isSupplyWarningON,
  isTemplateWarningON,
  isSubmissionWarningON,
  isPrepaid
}) => {
  const { deletionState } = useContext(DeletionContext);
  const isSearch = Object.keys(globalSearch).length > 0;
  const showNoInformationFound = !data.isLoading && data.data.length === 0;

  return (
    <div className="templates-desktop">
      {isSearch ? (
        <TemplatesDesktopSearchHeader
          onPageSizeChange={onPageSizeChange}
          pageSize={data.pageSize}
          showNoInformationFound={showNoInformationFound}
          onSearchDownload={onSearchDownload}
        />
      ) : (
        <TemplatesDesktopHeader
          tabs={tabs}
          tabIndex={data.tabIndex}
          onTabsChange={onTabsChange}
          pageSize={data.pageSize}
          onPageSizeChange={onPageSizeChange}
          isTemplateWarningON={isTemplateWarningON}
        />
      )}
      {showNoInformationFound && !isSearch ? (
        <NoInformationFound
          titleText={i18n.t('templates:NoTemplates')}
          subText={i18n.t('templates:NewTemplate1')}
          linkText={i18n.t('templates:NewTemplate2')}
          link="/templates/new"
        />
      ) : (
        !showNoInformationFound && (
          <PowerTable
            {...data}
            userName={userName}
            onPinClick={onPinClick}
            onMenuClick={onMenuRowClick}
            menuOptions={menuOptions}
            setPageState={setPageState}
            powerTableIndex={powerTableIndex}
            setAppState={setAppState}
            onOptionClick={onOptionClick}
            rowRules={rowRules}
            hasSettings
            isSupplyWarningON={isSupplyWarningON}
            isTemplateWarningON={isTemplateWarningON}
            isSubmissionWarningON={isSubmissionWarningON}
            isPrepaid={isPrepaid}
          />
        )
      )}
      {isSearch && showNoInformationFound && (
        <NoInformationFound
          titleText={i18n.t('templates:NoResults')}
          subText={i18n.t('templates:NoResultsBody')}
        />
      )}

      {/* //! Should get disabled if the deletion mode active: */}
      <div className="templates-desktop__pagination">
        <Pagination
          disabled={deletionState.isDeletionModeActive}
          onClick={onPageChange}
          currentPage={data.pageNumber}
          itemsPerPage={data.pageSize}
          totalItems={data.totalItems}
        />
      </div>
    </div>
  );
};

TemplatesDesktop.propTypes = {
  userName: PropTypes.string,
  setAppState: PropTypes.func,
  onMenuRowClick: PropTypes.func,
  onMoreOptionsClick: PropTypes.func,
  onPageChange: PropTypes.func,
  onTabsChange: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  onPinClick: PropTypes.func,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
  }),
  globalSearch: PropTypes.shape({
    submissionType: PropTypes.string,
  }),
  onPageSizeChange: PropTypes.func,
  onProceedDelete: PropTypes.func,
  onSearchDownload: PropTypes.func,
  powerTableIndex: PropTypes.number,
  setPageState: PropTypes.func,
  onOptionClick: PropTypes.func,
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  rowRules: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};

export default (props) => (
  <AppContext.Consumer>
    {(context) => (
      <TemplatesDesktop {...props} setAppState={context.setAppState} />
    )}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/containers/Templates/TemplatesDesktop/TemplatesDesktop.jsx